import ChooseContact from "components/AddresseePicker/ChooseContact";
import LabelledDivRow from "components/LabelledDivRow";
import CompanyModalPicker from "components/Picker/CompanyPicker/CompanyModalPicker";
import React from "react";

interface Props {
  company: server.dto.CompanySmall
  onCompanyChange: (company: server.dto.CompanySmall) => void

  contact: server.dto.ContactSmallV2
  onContactChange: (contact: server.dto.ContactSmallV2) => void
}

const HotelPanel = (props: Props) => {
  const hasHotel = props.company != null;

  return <LabelledDivRow label={site.currentEnvironment.functionGroups.hotel.singular}>
    <div>
      <CompanyModalPicker
        value={props.company}
        onChange={props.onCompanyChange}
        validatorKey="hotel"
        required={false}
        canCreateNew
        modalTitle={site.currentEnvironment.functionGroups.hotel.singular}
        addressType="regular"
      />
    </div>
    {hasHotel && <div className="flex-column gap-small">
      <ChooseContact
        company={props.company}
        selectedContact={props.contact}
        onContactChanged={props.onContactChange}
      />
    </div>}
  </LabelledDivRow>;
};

export default HotelPanel;